const errorHandler = (response) => {
  let errorModalHTML = '';

  if (sessionStorage.getItem('alreadyErrored')) {
    errorModalHTML = `<div class="modal error_handler active" id="errorModal"> <div class="modal-background"></div> <div class="inner"> <div class="close"></div> <div class="title">Sorry, there was a problem!</div> <div class="subtitle">Enter your email address to be notified when this problem has been resolved.</div> <div class="error_handler--form"> <input type="email" id="error_handler--email" name="email" placeholder="Email Address" class="form-item" required> <input type="hidden" name="response" value="${response}" id="error_handler--response" /> <button class="submit_error_form">Notify Me</button> </div> </div></div>`;
  } else {
    errorModalHTML = `<div class="modal error_handler active" id="errorModal"> <div class="modal-background"></div> <div class="inner"> <div class="close"></div> <div class="title">Sorry, there was a problem!</div> <div class="subtitle">Please reload the page and try again.</div> <div class="error_handler--form"><a href="#" onClick="window.location.reload();" class="submit_error_form button">Reload Page</a> </div> </div></div>`;
    sessionStorage.setItem('alreadyErrored', true);
  }

  let errorModal = document.createElement("div");
  errorModal.innerHTML = errorModalHTML;
  document.body.appendChild(errorModal);

  if (response !== '') {
    errorModal.querySelector('[name="response"]').value = response;
  }

  const formButton = errorModal.querySelector('.submit_error_form');
  formButton.addEventListener('click', () => {
    submitErrorForm();
  });

  const closeButton = errorModal.querySelector('.close');
  closeButton.addEventListener('click', () => {
    errorModal.querySelector('.error_handler').classList.remove('active');
  });

  const modalBackground = errorModal.querySelector('.modal-background');
  modalBackground.addEventListener('click', () => {
    errorModal.querySelector('.error_handler').classList.remove('active');
  });
}

const submitErrorForm = () => {
  console.log('Error form submitted');

  const errorForm = document.querySelector('.error_handler--form');
  const apiFailedAddToCart = 'https://app.get-nourished.com/api/klaviyo/failed-cart--uk';
  const email = document.getElementById('error_handler--email').value;
  let formResponse = document.getElementById('error_handler--response').value;

  const formData = {
    'email': email,
    'errorMessage': formResponse,
    'url': location.href
  };

  if (validateEmail(email)) {
    console.log('Email valid');
    fetch(apiFailedAddToCart, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(formData),
    }).then(function () {
      console.log('Fetch success');
      errorForm.remove();
      document.querySelector('.error_handler .title').textContent = 'Thank you';
      document.querySelector('.error_handler .subtitle').textContent = 'You will receive an email when this error has been resolved.';

      return;
    })
  } else {
    alert('Email not valid');
  }

}

function validateEmail(email) {
  return String(email)
    .toLowerCase()
    .match(
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    );
};

export default errorHandler;